import dayjs from "dayjs";

export const shouldHideWhatsNewForNewUser = (
  mspCreatedAt: string | null,
  whatsNewFeatureFlagCreatedAt: string | null,
): boolean => {
  if (!(mspCreatedAt && whatsNewFeatureFlagCreatedAt)) {
    return false;
  }
  return dayjs(mspCreatedAt).isAfter(dayjs(whatsNewFeatureFlagCreatedAt));
};
